import { useTranslation } from 'react-i18next';
import { useState } from "react";
import axios from "axios";



const Formulario = ({ lang, config }) => {
    const [codigo, setCodigo] = useState("");
    const [telefono, setTelefono] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    const { t } = useTranslation();

    var preidioma = ""
    if (lang != 'es') preidioma = lang + "/";


    const enviarGestionReserva = (idReserva) => {

        let token = document.getElementById('meta_token').getAttribute('content');

        const form = document.createElement("form");

        form.method = "POST";
        form.action = "/" + preidioma + "gestionareserva";

        const csrf = document.createElement("input");
        csrf.type = "hidden";
        csrf.name = "_token";
        csrf.value = token;

        const id = document.createElement("input");
        id.type = "hidden";
        id.name = "idReserva";
        id.value = idReserva;

        form.appendChild(csrf);
        form.appendChild(id);

        document.body.appendChild(form);
        form.submit();
    };


    const buscarReserva = async () => {
        setError("");

        if (!codigo.trim()) {
            setError("Debes introducir el código de reserva");
            return;
        }

        if (!telefono.trim()) {
            setError("Debes introducir el teléfono");
            return;
        }

        setLoading(true);

        try {
            const response = await axios.post("/buscagestionaeserva", {
                codigo: codigo,
                telefono: telefono,
                dataType: 'JSON'
            });

            // Suponiendo que el backend devuelve:
            // { id: 123 }

            const idReserva = response.data.id;

            if (idReserva) {
                enviarGestionReserva(idReserva);
            } else {
                setError("Reserva no encontrada o cliente no existe");
            }

        } catch (error) {
            console.error("Error buscando reserva:", error);

            setError("Reserva no encontrada o cliente no existe");
        } finally {
            setLoading(false);
        }
    };

    const accent = config.color_corporativo_web;

    return (
        <section className="py-5" style={{ minHeight: "60vh" }}>
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-12 col-md-7 col-lg-5">
                        <div className="bg-white rounded-4 shadow-sm p-4 p-md-5">

                            <div className="text-center mb-4">
                                <div
                                    className="d-inline-flex align-items-center justify-content-center rounded-circle mb-2"
                                    style={{ width: 40, height: 40, border: `1.5px solid ${accent}`, color: accent }}
                                >
                                    <i className="fa-solid fa-suitcase-rolling" style={{ fontSize: 14 }} aria-hidden="true"></i>
                                </div>
                                <h2 className="fw-light mb-0" style={{ fontSize: "0.95rem" }}>{t("Gestiona tu reserva")}</h2>
                            </div>

                            <div
                                className="rounded-3 p-3 mb-4 d-flex gap-3 bg-light"
                                style={{ borderLeft: `3px solid ${accent}` }}
                            >
                                <i className="fa-solid fa-circle-info mt-1" style={{ color: accent, fontSize: 14 }} aria-hidden="true"></i>
                                <div>
                                    <p className="mb-1 fw-light" style={{ fontSize: "0.85rem", lineHeight: 1.5 }}>
                                        {t("Desde esta página puedes cancelar tu reserva si así lo deseas.")}
                                    </p>
                                    <p className="mb-0 text-muted fw-light" style={{ fontSize: "0.8rem", lineHeight: 1.5 }}>
                                        {t("Recuerda leer las condiciones de la tarifa, ya que algunas tarifas no permiten modificaciones o tienen gastos de cancelación.")}
                                    </p>
                                </div>
                            </div>

                            <form
                                onSubmit={(e) => { e.preventDefault(); buscarReserva(); }}
                                noValidate
                            >
                                <div className="mb-3">
                                    <label htmlFor="codigo" className="form-label small text-uppercase text-muted">
                                        {t("Código reserva")}
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control form-control-sm fw-light"
                                        placeholder={t("Código")}
                                        name="codigo"
                                        required
                                        id="codigo"
                                        autoComplete="off"
                                        value={codigo}
                                        onChange={(e) => setCodigo(e.target.value)}
                                    />
                                </div>

                                <div className="mb-4">
                                    <label htmlFor="telefono" className="form-label small text-uppercase text-muted">
                                        {t("Teléfono")}
                                    </label>
                                    <input
                                        type="tel"
                                        className="form-control form-control-sm fw-light"
                                        placeholder={t("Teléfono")}
                                        name="telefono"
                                        id="telefono"
                                        autoComplete="tel"
                                        value={telefono}
                                        onChange={(e) => setTelefono(e.target.value)}
                                    />
                                </div>

                                {error && (
                                    <div className="alert alert-danger d-flex align-items-center gap-2 py-2" role="alert">
                                        <i className="fa-solid fa-circle-exclamation" aria-hidden="true"></i>
                                        <span>{error}</span>
                                    </div>
                                )}

                                <button
                                    type="submit"
                                    className="btn btn-sm w-100 text-white fw-light"
                                    disabled={loading}
                                    style={{ background: accent, borderColor: accent }}
                                >
                                    {loading ? (
                                        <>
                                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                            {t("Buscando...")}
                                        </>
                                    ) : (
                                        t("Ver reserva")
                                    )}
                                </button>
                            </form>

                        </div>
                    </div>
                </div>
            </div>
        </section>
    )

};

export default Formulario;